/* eslint-disable */
import * as React from 'react';
import { ThemeContext } from './ThemeProviderWithFonts';
import { ErrorReporting } from '../base/errorHandling/ErrorReporting';

type MapThemeProps<T> = (theme: T) => T;

export const useTheme = <T extends object>(key: string, mapThemeProps: MapThemeProps<T>): T => {
  const reporter = React.useContext(ErrorReporting);
  const themeContext = React.useContext(ThemeContext);

  if (themeContext[key]) {
    return mapThemeProps(themeContext[key]);
  }

  reporter.reportWarning(`cannot find key: ${key} in configuration`);
  return {} as T;
};
